var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777",
    transform: "translate(-963 -1513)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(963 1513)",
    fill: "#83b797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M9.26,13a2,2,0,0,1,.01-2.01A3,3,0,0,0,9,5H5a3,3,0,0,0,0,6h.08a6.06,6.06,0,0,0,0,2H5A5,5,0,1,1,5,3H9a5,5,0,0,1,.26,10Zm1.48-6a2,2,0,0,1-.01,2.01A3,3,0,0,0,11,15h4a3,3,0,0,0,0-6h-.08a6.06,6.06,0,0,0,0-2H15a5,5,0,0,1,0,10H11a5,5,0,1,1-.26-10Z",
    transform: "translate(973 1523)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.faf7cbd669dd4949302598379237ebee.svg";
export { ForwardRef as ReactComponent };